import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
/**
 *
 * Subscription Emit Service
 * @export
 * @ class SubscriptionEmitService
 */
@Injectable({ providedIn: 'root' })
export class SubscriptionEmitService {
  /** Return events data */
  // eslint-disable-next-line @typescript-eslint/ban-types
  private readonly data: object = {};
  constructor() {}

  public emit<T>(emitterName: string, data: T): void {
    if (this.data[emitterName] instanceof Subject) {
      this.data[emitterName].next(data);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public register<T>(emitterName: string): void {
    if (this.data[emitterName] === undefined) {
      this.data[emitterName] = new Subject();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public emitterOf<T>(emitterName: string): Observable<T> {
    if (this.data[emitterName] && this.data[emitterName] instanceof Subject) {
      return this.data[emitterName] as Observable<T>;
    }
  }

  // eslint-disable-next-line id-blacklist
  public on<T>(emitterName: string, callback: (any) => void): Subscription {
    if (!this.data[emitterName]) {
      this.register(emitterName);
    }
    return (this.data[emitterName] as Observable<T>).subscribe(callback);
  }

  public trigger<T>(emitterName: string, data: T): void {
    if (!this.data[emitterName]) {
      this.register(emitterName);
    }
    if (this.data[emitterName] instanceof Subject) {
      this.data[emitterName].next(data);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public unRegister<T>(emitterName: string): void {
    this.data[emitterName] = undefined;
  }
}
